import { matchPath, Params } from 'react-router';

export const getLocationParams = (pathname: string, pathPattern: string) => {
  const match = matchPath(pathname, pathPattern);

  const searchParams = new URLSearchParams(window.location.search);

  return {
    params: match?.params,
    query: searchParams,
  };
};
